import { render, staticRenderFns } from "./UserRoleSelector.vue?vue&type=template&id=417b78b6&scoped=true"
import script from "./UserRoleSelector.vue?vue&type=script&lang=js"
export * from "./UserRoleSelector.vue?vue&type=script&lang=js"
import style0 from "./UserRoleSelector.vue?vue&type=style&index=0&id=417b78b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417b78b6",
  null
  
)

export default component.exports